import Reveal from "@/components/site/Reveal";

export default function FinalCTA({ onStartProject }) {
  return (
    <section
      id="start"
      data-testid="final-cta-section"
      className="relative bg-[#141310] py-40 md:py-64 text-center overflow-hidden"
    >
      <div className="relative max-w-5xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.36em] text-[#9c7a4e] mb-14">Begin</p>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="font-display font-light text-[#F5F3EE] leading-[1.0] tracking-[-0.01em] text-5xl sm:text-7xl md:text-8xl lg:text-[7rem]">
            Let&rsquo;s create<br />something enduring.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <button
            data-testid="final-start-project"
            onClick={onStartProject}
            className="mt-16 text-[12px] tracking-[0.24em] uppercase px-12 py-5 bg-[#F5F3EE] text-[#141310] hover:bg-[#9c7a4e] hover:text-[#F5F3EE] transition-colors duration-500"
          >
            Start a Project
          </button>
        </Reveal>
      </div>
    </section>
  );
}
